import { generateMessageTemplateKey, useMessageTemplate } from 'hooks';
import { getMessageTemplateKey } from './LumaBot.utils';

export const useLumaBotGetTemplateText = (lumabotKey: string) => {
  const lumabotTemplateKey = generateMessageTemplateKey(lumabotKey);
  const templateKey = getMessageTemplateKey(lumabotTemplateKey);
  const templateText = useMessageTemplate(templateKey);
  return templateText;
};
